import { appcuesAccountIdFactory } from '../factories/appcues-account-id.factory';
import { APPCUES_ACCOUNT_ID } from '../tokens/appcues-account-id.token';
import { WINDOW } from '../tokens/window.token';
import { FactoryProvider } from '@angular/core';

export const APPCUES_ACCOUNT_ID_PROVIDER: FactoryProvider = {
  deps: [WINDOW],
  provide: APPCUES_ACCOUNT_ID,
  useFactory: appcuesAccountIdFactory,
};
